import {Modal, Text, UnstyledButton} from '@mantine/core'
import * as Sentry from '@sentry/react'
import {IconMessageReport} from '@tabler/icons-react'
import {useRef, useState} from 'react'

import classes from '../app-shell/app-navbar.module.css'
import {isSentryEnabled} from './is-sentry-enabled'

type FeedbackDialog = {
    appendToDom: () => void
    removeFromDom: () => void
    open: () => void
    close: () => void
}

type FeedbackNavButtonProps = {
    onNavigate?: () => void
}

export function FeedbackNavButton({onNavigate}: FeedbackNavButtonProps) {
    const [devModalOpen, setDevModalOpen] = useState(false)
    const [isOpening, setIsOpening] = useState(false)
    const formRef = useRef<FeedbackDialog | null>(null)
    const sentryEnabled = isSentryEnabled()

    const handleClick = async () => {
        if (!sentryEnabled) {
            setDevModalOpen(true)
            onNavigate?.()
            return
        }

        const feedback = Sentry.getFeedback()
        if (!feedback || isOpening) {
            return
        }

        setIsOpening(true)
        try {
            if (!formRef.current) {
                formRef.current = await feedback.createForm({
                    formTitle: 'Send Feedback',
                    onFormSubmitted: () => {
                        formRef.current?.removeFromDom()
                        formRef.current = null
                    },
                })
            }

            formRef.current.appendToDom()
            formRef.current.open()
            onNavigate?.()
        } finally {
            setIsOpening(false)
        }
    }

    return (
        <>
            <UnstyledButton
                className={classes['link']}
                fz="sm"
                aria-label="Feedback"
                type="button"
                onClick={() => {
                    void handleClick()
                }}
            >
                <IconMessageReport className={classes['linkIcon']} size={18} stroke={1.5} />
                <span className={classes['linkLabel']}>Feedback</span>
            </UnstyledButton>

            {!sentryEnabled && (
                <Modal
                    opened={devModalOpen}
                    onClose={() => setDevModalOpen(false)}
                    title="Feedback"
                    transitionProps={{duration: 0}}
                >
                    <Text>Sentry feedback is only available in Prod.</Text>
                </Modal>
            )}
        </>
    )
}
